import { matchPattern } from 'react-router/es/PatternUtils';

import { Language } from '@ha/intl';

export default function getLanguageFromUrl(url: string): Language {
  const urlProperties = matchPattern('/(:lang)', url);
  const langFromUrl = urlProperties && urlProperties.paramValues[0];

  if (!langFromUrl) {
    return Language.en;
  }

  return Language[langFromUrl] || Language.en;
}
